/* eslint-disable no-tabs */
import { SocialLoginPayload } from 'pages/Login/components/SocialLogin/SocialLogin.props';
import BaseService from './base';
import { AUTH } from '../common/endpoints';

export interface TokenPayload {
  username: string;
  password: string;
}

interface PasswordResetPayload {
  email: string;
}

interface PasswordChangePayload {
  new_password: string;
  re_new_password: string;
  uid: string;
  token: string;
}

interface BackupCodesPayload {
  user_has_totp_device: boolean;
  confirmed: boolean;
  persistent_id?: string;
}

export interface RefreshTokenPayload {
  refresh?: string;
}

export interface VerifyAccessTokenPayload {
  token: string;
}

class AuthService extends BaseService {
  static instance: AuthService;

  constructor() {
    super();
    if (!AuthService.instance) {
      AuthService.instance = this;
    }
  }

  static getInstance() {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  getAccessTokens = (payload: TokenPayload) => this.post(AUTH.getAccessTokens, payload);

  sendAccessToken = (payload: SocialLoginPayload) => this.postNoAuth(AUTH.sendAccessToken, payload);

  refreshAccessToken = (payload: string | RefreshTokenPayload) => this.post(AUTH.refreshAccessToken, payload);

  verifyAccessToken = (accessToken: VerifyAccessTokenPayload) => this.post(AUTH.verifyAccessToken, accessToken);

  createUser = (data: unknown) => this.postNoAuth(AUTH.createUser, data);

  getUserInfo = () => this.get(AUTH.getUserInfo);

  updateUserProfileInfo = (payload: unknown) => this.put(AUTH.updateUserProfileInfo, payload);

  activateUser = (uid: string, token: string) => this.postNoAuth(AUTH.activateUser, { uid, token });

  resendActivationEmail = (email: string) => this.postNoAuth(AUTH.resendActivationEmail, { email });

  sendPasswordReset = (payload: PasswordResetPayload) => this.postNoAuth(AUTH.resetPassword, payload);

  sendPasswordChange = (payload: PasswordChangePayload) => this.postNoAuth(AUTH.passwordChange, payload);

  verifyOTP = (token: string) => this.post(AUTH.verifyOTP(token));

  getBackupCodes = () => this.get(AUTH.getBackupCodes);

  createBackupCodes = (data: BackupCodesPayload) => this.post(AUTH.createBackupCodes, data);

  verifyBackupCode = (backupCode: string) => this.post(AUTH.verifyBackupCode(backupCode));

  getTOTP = () => this.get(AUTH.getTOTP);

  createTOTP = () => this.get(AUTH.createTOTP);

  updateTOTP = (data: unknown) => this.post(AUTH.updateTOTP, data);

  deleteTOTP = () => this.post(AUTH.deleteTOTP);
}

export default AuthService;
